import {FranchisesTableParams, ProcedureGroup} from 'domain/usecases';
import {makeGetFranchisesTable} from 'main/factories/usecases/private/franchises-table-flow';
import {FilteredItemsListContents} from 'presentation/pages/private/hooks/useGetPaginatedItems/types';
import {getTotalPages} from 'presentation/utils';

export async function getFranchisesTable(params: FranchisesTableParams) {
	const response = await makeGetFranchisesTable().get(params);
	if (!response) {
		return {
			items: [],
			total: 0,
			pages: 0,
			groups: [],
		};
	}

	const totalPages = getTotalPages({
		totalItems: response.totalItems,
		itemsPerPage: response.itemsPerPage,
		limit: params.limit,
	});

	const filteredItemsListContents: FilteredItemsListContents<ProcedureGroup> = {
		items: response?.grupoProcedimento,
		total: response?.totalItems,
		pages: totalPages,
		groups: response?.grupos,
	};

	return filteredItemsListContents;
}
